// extracted by mini-css-extract-plugin
module.exports = {"bannerItem":"Banner_bannerItem__1hEOC"};